// Cannot be moved to CRA alias
import { labelValueMap, valueLabelMap } from '../utils/helpers';

export enum AccountStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  DENIED = 'denied',
}

export const accountStatuses = [
  {
    label: 'Pending',
    value: 'pending',
  },
  {
    label: 'Approved',
    value: 'approved',
  },
  {
    label: 'Denied',
    value: 'denied',
  },
];

export const accountStatusMap = valueLabelMap(accountStatuses);

export const reverseAccountStatusMap = labelValueMap(accountStatuses);
